import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root',
})
export class MfaOnboardingService {
  public endpoint = 'v3/mfa_onboarding'

  constructor(
    private api: UserServiceApiService,
  ) {
    // noop
  }

  public enable(): Observable<any> {
    const url = `${this.endpoint}/enable`
    return this.api.post<any>(
      url,
      {}
    ).pipe(
      map(response => response.result)
    )
  }

  public skip(): Observable<any> {
    const url = `${this.endpoint}/skip`
    return this.api.get<any>(
      url
    ).pipe(
      map(response => response.result)
    )
  }

  public complete(): Observable<any> {
    const url = `${this.endpoint}/complete`
    return this.api.get<any>(
      url
    ).pipe(
      map(response => response.result)
    )
  }
}
